// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"12e69c70","921":"3d8fb96f"}[chunkId] + ".chunk.js";
};